import React from 'react';
import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { observer } from "mobx-react-lite";
import { AssessmentOutlined, AssignmentOutlined, CloudOutlined, DashboardOutlined, InsertDriveFile, InsertDriveFileOutlined, StoreOutlined, SupportOutlined } from '@mui/icons-material';
import { withRouter } from 'react-router';
import { getSiteById } from '../../selectors/SiteSelectors';
import { INTERNAL_HEADER_HEIGHT } from '../../constants/Constants';
import { NAV_TEXT_STYLE, FOOTER_STYLE } from '../../constants/Styles';
import packageJson from "../../../package.json";
import Colors from '../../constants/Colors';
import MenuStore from '../../stores/internal/MenuStore';

const DRAWER_WIDTH = 200;

const InternalSiteHeader = ({ match, history, location }) => {
  const site = getSiteById(match.params.site_id);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDrawerOpen = MenuStore.isDrawerOpen;

  const prepareMenuItems = (site_id) => {
    const menuItems = [
      { title: "Dashboard", icon: <DashboardOutlined />, link: `/dashboard/site/${site_id}` },
      { title: "Hosting", icon: <CloudOutlined />, link: `/dashboard/site/${site_id}/hosting` },
      { title: "Support", icon: <SupportOutlined />, link: `/dashboard/site/${site_id}/support`},
      { title: "Activity", icon: <AssessmentOutlined />, link: `/dashboard/site/${site_id}/activity` },
      { title: "Projects", icon: <AssignmentOutlined />, link: `/dashboard/site/${site_id}/projects` },
      { title: "Account", icon: <StoreOutlined />, link: `/dashboard/site/${site_id}/account` },
    ];
  
    if (
      site &&
      site.site_external_connections &&
      site.site_external_connections.wordpress &&
      site.site_external_connections.wordpress.wordpress_content_creation_enabled
    ) {
      const insertIndex = menuItems.findIndex(item => item.title === "Support") + 1;
  
      menuItems.splice(insertIndex, 0, {
        title: "Content",
        icon: <InsertDriveFileOutlined />,
        link: `/dashboard/site/${site_id}/content`,
        isNew: true
      });
    }
  
    return menuItems;
  };
  

  const handleNav = (path) => {
    history.push(path);
    if (isMobile) {
      MenuStore.setIsDrawerOpen(false);
    }
  };

  return (
    <Drawer
      anchor="left"
      variant={isMobile ? "temporary" : "permanent"}
      open={isMobile ? isDrawerOpen : true}
      onClose={() => MenuStore.setIsDrawerOpen(false)}
      ModalProps={{ keepMounted: true }}
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        zIndex: isMobile ? 1301 : 'auto',
        '& .MuiDrawer-paper': {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
          position: isMobile ? 'fixed' : 'fixed',
          height: isMobile ? '100vh' : `calc(100vh - ${INTERNAL_HEADER_HEIGHT}px)`,
          top: isMobile ? 0 : INTERNAL_HEADER_HEIGHT,
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <List>
          {prepareMenuItems(site ? site.site_id : '').map(item => {
            const isDashboard = item.title === "Dashboard";
            const isActive = isDashboard
              ? location.pathname === item.link
              : location.pathname === item.link || location.pathname.startsWith(item.link + '/');

            return (
              <ListItem
                button
                key={item.title}
                onClick={() => handleNav(item.link)}
                sx={{
                  backgroundColor: isActive ? Colors.primaryColor : 'transparent',
                  '&:hover': { backgroundColor: isActive ? Colors.primaryColor : '#f5f5f5' },
                }}
              >
                <ListItemIcon sx={{ color: isActive ? '#fff' : 'inherit' }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <span style={{ ...NAV_TEXT_STYLE, color: isActive ? '#fff' : 'inherit' }}>
                      {item.title}
                      {item.isNew && (
                        <span
                          style={{
                            backgroundColor: '#ff4081',
                            color: 'white',
                            borderRadius: '8px',
                            padding: '2px 6px',
                            fontSize: '0.6rem',
                            fontWeight: 600,
                            textTransform: 'uppercase',
                          }}
                        >
                          New
                        </span>
                      )}
                    </span>
                  }
                />
              </ListItem>
            );
          })}
        </List>

        <Box sx={{ ...FOOTER_STYLE, display: 'flex', flexDirection: { xs: 'column', sm: 'column', md: 'row' }, justifyContent: 'space-between', zIndex: 1300 }}>
          <Box sx={{ width: '100%', textAlign: 'center' }}>
            Developed by <b>BCK</b>
            <br />
            v.{packageJson.version}
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default withRouter(observer(InternalSiteHeader));
